const isValidId = value =>
  /^[1-3](19|20)\d{2}[7-8]\d{7}[0-9]\d{2}$/.test(value) ||
  /^[a-zA-Z]{1,2}[0-9]{6,7}/.test(value) ||
  /^(\d{12}|\d{16})$/.test(value);

export default isValidId;
